
import { useState } from 'react';

interface Product {
  id: number;
  title: string;
  description: string;
  features: string[];
  image: string;
}

export default function Products() {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  const products: Product[] = [
    {
      id: 1,
      title: "Portes en Fer Modernes",
      description: "Des portes robustes alliant sécurité et design contemporain",
      features: [
        "Sécurité Renforcée - Des portes robustes assurant une protection optimale",
        "Design Contemporain - Un style moderne, élégant et adaptable à tous les environnements",
        "Personnalisation - Motifs, couleurs, épaisseurs et finitions adaptés à vos besoins"
      ],
      image: "https://public.readdy.ai/ai/img_res/ae1a7bc91c33f219995ddf30b19ce789.jpg"
    },
    {
      id: 2,
      title: "Aluminium & Inox : Solutions Haut de Gamme",
      description: "Structures modernes avec performance énergétique optimale",
      features: [
        "Design Moderne - Structures au style épuré et contemporain",
        "Performance Énergétique - Isolation thermique et acoustique optimale",
        "Flexibilité d'Installation - Solutions sur mesure pour tout type d'espace"
      ],
      image: "https://readdy.ai/api/search-image?query=Premium%20aluminum%20and%20stainless%20steel%20window%20frames%20and%20doors%2C%20modern%20sleek%20metal%20structures%20with%20clean%20contemporary%20design%2C%20high-end%20architectural%20metalwork%20with%20polished%20finish%2C%20energy-efficient%20aluminum%20installation%20with%20glass%20panels%2C%20professional%20quality%20metal%20framework%2C%20minimalist%20design%20with%20precise%20engineering%2C%20simple%20neutral%20background%2C%20product%20photography%20highlighting%20metal%20details%20and%20craftsmanship&width=600&height=800&seq=product-aluminum&orientation=portrait"
    },
    {
      id: 3,
      title: "Systèmes Guillotine & Accordéon",
      description: "Solutions flexibles pour espaces commerciaux et résidentiels",
      features: [
        "Design Élégant - Adapté aux cafés, restaurants et espaces commerciaux",
        "Flexibilité Maximale - Ouverture totale ou partielle selon vos besoins",
        "Performance Fiable - Systèmes motorisés ou manuels durables et sécurisés"
      ],
      image: "https://readdy.ai/api/search-image?query=Modern%20guillotine%20and%20accordion%20folding%20door%20system%2C%20commercial%20grade%20retractable%20metal%20door%20mechanism%2C%20elegant%20folding%20glass%20and%20metal%20structure%20for%20cafe%20or%20restaurant%2C%20flexible%20opening%20system%20with%20clean%20design%2C%20professional%20installation%20with%20smooth%20operation%2C%20contemporary%20architectural%20solution%2C%20neutral%20background%20showcasing%20the%20door%20system%2C%20high-quality%20product%20photography%20with%20attention%20to%20mechanism%20details&width=600&height=800&seq=product-guillotine&orientation=portrait"
    },
    {
      id: 4,
      title: "Balcons & Escaliers Métalliques",
      description: "Structures robustes au design moderne et fonctionnel",
      features: [
        "Esthétique Moderne - Design adaptable à différents styles d'architecture",
        "Robustesse - Métal de haute qualité assurant sécurité et longévité",
        "Fonctionnalité - Conception pour le confort, l'élégance et la résistance"
      ],
      image: "https://readdy.ai/api/search-image?query=Modern%20metal%20balcony%20railing%20and%20staircase%20with%20contemporary%20design%2C%20elegant%20iron%20or%20steel%20balustrade%20with%20geometric%20patterns%2C%20architectural%20metalwork%20for%20exterior%20or%20interior%20use%2C%20high-quality%20metal%20construction%20with%20durable%20finish%2C%20sleek%20modern%20design%20with%20clean%20lines%2C%20professional%20craftsmanship%20in%20metal%20fabrication%2C%20simple%20background%20highlighting%20the%20structure%2C%20architectural%20photography%20showcasing%20metal%20details&width=600&height=800&seq=product-balcony&orientation=portrait"
    },
    {
      id: 5,
      title: "Balcons & Escaliers en Verre",
      description: "Transparence moderne pour espaces lumineux et ouverts",
      features: [
        "Esthétique - Transparence moderne pour une intégration parfaite",
        "Luminosité Maximale - Création d'espaces ouverts et lumineux",
        "Durabilité & Sécurité - Verre trempé ultra-résistant avec fixations professionnelles"
      ],
      image: "https://readdy.ai/api/search-image?query=Modern%20glass%20balcony%20railing%20and%20staircase%20with%20metal%20fixtures%2C%20contemporary%20transparent%20glass%20balustrade%20with%20stainless%20steel%20supports%2C%20elegant%20minimalist%20design%20with%20tempered%20glass%20panels%2C%20architectural%20glass%20and%20metal%20combination%20for%20modern%20spaces%2C%20clean%20professional%20installation%20with%20maximum%20transparency%2C%20sophisticated%20design%20allowing%20natural%20light%2C%20neutral%20background%20showcasing%20glass%20clarity%2C%20high-end%20architectural%20photography&width=600&height=800&seq=product-glass-balcony&orientation=portrait"
    },
    {
      id: 6,
      title: "Pergola Bioclimatique",
      description: "Confort optimal avec gestion naturelle de la lumière",
      features: [
        "Confort Optimal - Gestion naturelle de la lumière et de la ventilation",
        "Protection - Efficace contre le soleil et les intempéries",
        "Durabilité - Matériaux premium conçus pour durer"
      ],
      image: "https://readdy.ai/api/search-image?query=Modern%20bioclimatic%20pergola%20with%20adjustable%20aluminum%20louvers%2C%20contemporary%20outdoor%20structure%20with%20rotating%20slats%20for%20sun%20control%2C%20elegant%20metal%20pergola%20with%20clean%20architectural%20design%2C%20premium%20quality%20aluminum%20construction%20for%20terrace%20or%20patio%2C%20sophisticated%20weather%20protection%20system%2C%20professional%20installation%20with%20sleek%20finish%2C%20simple%20background%20highlighting%20the%20pergola%20structure%2C%20architectural%20photography%20showcasing%20functionality%20and%20design&width=600&height=800&seq=product-pergola&orientation=portrait"
    },
    {
      id: 7,
      title: "Bâches sur Mesure",
      description: "Protection totale adaptée à toutes dimensions",
      features: [
        "Résistance Extrême - Adaptées aux conditions climatiques difficiles",
        "Protection Totale - Idéales pour espaces professionnels et résidentiels",
        "Adaptabilité - Fabrication sur mesure pour toutes dimensions"
      ],
      image: "https://readdy.ai/api/search-image?query=Custom%20professional%20tarpaulin%20and%20canvas%20covers%20for%20commercial%20use%2C%20heavy-duty%20weather-resistant%20fabric%20protection%2C%20high-quality%20industrial%20grade%20tarp%20with%20metal%20reinforcements%2C%20durable%20outdoor%20covering%20solution%20with%20clean%20finish%2C%20professional%20installation%20for%20various%20applications%2C%20neutral%20color%20weather%20protection%20material%2C%20simple%20background%20showcasing%20material%20quality%2C%20product%20photography%20highlighting%20durability%20and%20craftsmanship&width=600&height=800&seq=product-tarp&orientation=portrait"
    },
    {
      id: 8,
      title: "Cuisines en Aluminium Durables",
      description: "Design moderne avec finitions élégantes",
      features: [
        "Résistance - Anti-humidité, anti-chocs, anti-corrosion",
        "Design Moderne - Finitions élégantes, adaptées à tous les intérieurs",
        "Personnalisation - Large choix de styles, couleurs et configurations"
      ],
      image: "https://readdy.ai/api/search-image?query=Modern%20aluminum%20kitchen%20cabinets%20with%20sleek%20contemporary%20design%2C%20high-quality%20metal%20kitchen%20furniture%20with%20elegant%20finish%2C%20durable%20aluminum%20cabinetry%20with%20clean%20lines%20and%20modern%20handles%2C%20professional%20kitchen%20installation%20with%20premium%20materials%2C%20moisture-resistant%20metal%20kitchen%20units%2C%20sophisticated%20interior%20design%20with%20neutral%20colors%2C%20simple%20background%20highlighting%20cabinet%20details%2C%20product%20photography%20showcasing%20quality%20and%20craftsmanship&width=600&height=800&seq=product-kitchen&orientation=portrait"
    },
    {
      id: 9,
      title: "Parois & Vitrines de Haute Qualité",
      description: "Verre trempé offrant esthétique raffinée et durabilité",
      features: [
        "Clarté - Verre trempé offrant une esthétique raffinée",
        "Durabilité - Résistance élevée aux chocs et à l'usure",
        "Sécurité - Fixations professionnelles pour une utilisation fiable"
      ],
      image: "https://readdy.ai/api/search-image?query=Modern%20glass%20partition%20walls%20and%20display%20cases%20with%20metal%20frames%2C%20contemporary%20tempered%20glass%20panels%20with%20professional%20fixtures%2C%20elegant%20glass%20showcase%20for%20commercial%20or%20residential%20use%2C%20high-quality%20transparent%20glass%20installation%20with%20clean%20design%2C%20sophisticated%20glass%20and%20metal%20combination%2C%20professional%20craftsmanship%20with%20secure%20mounting%2C%20simple%20background%20highlighting%20glass%20clarity%2C%20architectural%20photography%20showcasing%20transparency%20and%20quality&width=600&height=800&seq=product-glass-wall&orientation=portrait"
    },
    {
      id: 10,
      title: "Alucobond",
      description: "Panneaux composites pour façades modernes et professionnelles",
      features: [
        "Panneaux composites pour façades modernes et professionnelles",
        "Offrant isolation, durabilité et design élégant",
        "Solution idéale pour revêtements extérieurs contemporains"
      ],
      image: "https://readdy.ai/api/search-image?query=Modern%20alucobond%20composite%20panels%20for%20building%20facade%2C%20contemporary%20aluminum%20composite%20cladding%20with%20sleek%20finish%2C%20professional%20architectural%20exterior%20panels%20with%20clean%20design%2C%20high-quality%20building%20material%20with%20modern%20aesthetic%2C%20durable%20facade%20solution%20with%20elegant%20appearance%2C%20commercial%20grade%20composite%20panels%20installation%2C%20simple%20background%20showcasing%20panel%20texture%20and%20quality%2C%20architectural%20photography%20highlighting%20material%20sophistication&width=600&height=800&seq=product-alucobond&orientation=portrait"
    },
    {
      id: 11,
      title: "Moustiquaires en Aluminium",
      description: "Protection efficace contre les insectes",
      features: [
        "Moustiquaires résistantes et pratiques",
        "Adaptées aux portes et fenêtres",
        "Protection efficace tout en conservant la luminosité"
      ],
      image: "https://readdy.ai/api/search-image?query=Modern%20aluminum%20mosquito%20screen%20for%20windows%20and%20doors%2C%20contemporary%20insect%20protection%20mesh%20with%20metal%20frame%2C%20high-quality%20retractable%20or%20fixed%20screen%20system%2C%20durable%20aluminum%20frame%20with%20fine%20mesh%2C%20practical%20solution%20for%20ventilation%20and%20insect%20protection%2C%20clean%20professional%20installation%2C%20simple%20background%20highlighting%20screen%20quality%2C%20product%20photography%20showcasing%20functionality%20and%20design&width=600&height=800&seq=product-mosquito&orientation=portrait"
    }
  ];

  return (
    <section id="products" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1E3A5F] mb-6">
            Notre Catalogue de Produits
          </h2>
          <div className="w-24 h-1 bg-[#A83232] mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez notre gamme complète de solutions métalliques haut de gamme
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product) => (
            <div 
              key={product.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
              onClick={() => setSelectedProduct(product)}
            >
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">
                  {product.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {product.description}
                </p>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedProduct(product);
                  }}
                  className="w-full bg-[#A83232] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#8A2828] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Voir les détails
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedProduct && (
        <div 
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedProduct(null)}
        >
          <div 
            className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <img 
                src={selectedProduct.image}
                alt={selectedProduct.title}
                className="w-full h-96 object-cover object-top"
              />
              <button 
                onClick={() => setSelectedProduct(null)}
                className="absolute top-4 right-4 bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-[#1E3A5F]"></i>
              </button>
            </div>
            <div className="p-8">
              <h3 className="text-3xl font-bold text-[#1E3A5F] mb-4">
                {selectedProduct.title}
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                {selectedProduct.description}
              </p>
              <div className="space-y-4">
                {selectedProduct.features.map((feature, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-[#A83232] text-xl"></i>
                    </div>
                    <p className="text-gray-700">{feature}</p>
                  </div>
                ))}
              </div>
              <div className="mt-8 flex gap-4">
                <a 
                  href="#contact"
                  onClick={() => setSelectedProduct(null)}
                  className="flex-1 bg-[#A83232] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#8A2828] transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
                >
                  Demander un devis
                </a>
                <button 
                  onClick={() => setSelectedProduct(null)}
                  className="px-6 py-3 border-2 border-[#1E3A5F] text-[#1E3A5F] rounded-lg font-semibold hover:bg-[#1E3A5F] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
